const MONTHS_ES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

/**
 * Parses API datetime strings like "2025-03-17T09:00:00" without timezone shifting.
 */
export const parseApiDateTime = (iso) => {
  if (!iso || typeof iso !== "string") {
    return { date: "-", time: "-" };
  }

  const [datePart, timePart] = iso.split("T");
  if (!datePart || !timePart) {
    return { date: iso, time: "-" };
  }

  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute] = timePart.split(":").map(Number);

  if (!year || !month || !day || Number.isNaN(hour) || Number.isNaN(minute)) {
    return { date: datePart, time: timePart };
  }

  const period = hour >= 12 ? "p.m." : "a.m.";
  const hour12 = hour % 12 || 12;
  const date = `${day} de ${MONTHS_ES[month - 1]} de ${year}`;
  const time = `${String(hour12).padStart(2, "0")}:${String(minute).padStart(
    2,
    "0"
  )} ${period}`;

  return { date, time };
};
